export default __webpack_public_path__ + "static/video1-079ffd7c61a61517cbfa8b71067b5789.jpg";